import { Object3D } from "three"
import { clone as cloneSkinnedHierarchy } from "three/examples/jsm/utils/SkeletonUtils.js"
import { GLBModel } from "./GLBModel"

function defaultNodeModelKey(path: string, nodeName: string) {
  const base = path.split('/').pop() ?? path
  const fileKey = base.replace(/\.glb$/i, '')
  const nodeKey = nodeName.replace(/[^a-z0-9]+/gi, '_').toLowerCase()
  return `${fileKey}_${nodeKey}`
}

export class GLBNodeModel extends GLBModel {
  constructor(
    path: string,
    public readonly nodeName: string,
    private readonly keyOverride?: string,
  ) {
    super(path)
  }

  override get key(): string {
    return this.keyOverride ?? defaultNodeModelKey(this.path, this.nodeName)
  }

  override getModel(): Object3D | null {
    const scene = this.gltf?.scene
    if (!scene) return null

    const src = scene.getObjectByName(this.nodeName)
    if (!src) {
      console.warn(`[GLBNodeModel] node not found: ${this.nodeName} in ${this.path}`)
      return null
    }

    const node = cloneSkinnedHierarchy(src) as Object3D
    node.name = this.key
    return node
  }
}
